import { gql } from "@apollo/client";

import { Category } from "../types";

export const sessionsQuery = gql`
    query GetSessions($userId: ID!, $limit: Int, $offset: Int) {
        sessions(userId: $userId, limit: $limit, offset: $offset) {
            nodes {
                id
                durationTotal
                durationEndurance
                durationStrength
                durationCoordination
                durationRelaxation
                durationMobility
                durationAi
                exercises {
                    id
                    nameDe
                    nameEn
                    category
                }
                aiExercises
                createdAt
            }
            totalCount
            totalDuration
            totalDurationEndurance
            totalDurationStrength
            totalDurationMobility
            totalDurationRelaxation
            totalDurationCoordination
            totalDurationAi
            totalDurationThisWeek
        }
    }
`;

export interface GetSessionsType {
    sessions: {
        nodes: Array<{
            id: string;
            durationTotal: number;
            durationEndurance: number;
            durationStrength: number;
            durationCoordination: number;
            durationRelaxation: number;
            durationMobility: number;
            durationAi: number;
            exercises: Array<{
                id: number;
                nameDe: string;
                nameEn: string;
                category: Category;
            }>;
            aiExercises: string[];
            createdAt: string;
        }>;
        totalCount: number;
        totalDuration: number;
        totalDurationEndurance: number;
        totalDurationStrength: number;
        totalDurationMobility: number;
        totalDurationRelaxation: number;
        totalDurationCoordination: number;
        totalDurationAi: number;
        totalDurationThisWeek: number;
    };
}

export interface GetSessionsVariables {
    userId: string;
    limit: number;
    offset: number;
}

export const countedSettingsQuery = gql`
    query GetCountedSettings($userId: ID!, $limit: Int, $offset: Int) {
        countedSettings(userId: $userId, limit: $limit, offset: $offset) {
            nodes {
                id
                name
                discreet
                favourite
                categories
            }
            totalCount
        }
    }
`;
